export const manual = [
    {
        date: "SUNDAY 7TH JULY, 2024",
        lesson: "Lesson 1",
        topic: "Potentialities in Prayer and Fasting",
        text: "Mark 9:17-29",
        memory_verse: "Mark 9:23 (KJV) - \"Jesus said unto him, If thou canst believe, all things are possible to him that believeth.\"",
        central_truth: "Prayer and fasting have the potential to reverse what seemed impossible.",
        aim: "To teach that the efficacy or deficiency of prayer and fasting is based on our belief system.",
        introduction: "Review the week's devotional for deeper insight. Potentialities in prayer and fasting refer to their capabilities to achieve significant results. These practices are powerful tools for overcoming challenges and accomplishing goals. The effectiveness of prayer and fasting depends on our belief in their power. In the passage, the father of the afflicted child had no faith, relying solely on Jesus’ faith for healing. It demonstrates that belief is crucial for the success of prayer and fasting.",
        main_point: [
            "A man approached Jesus with his son suffering from a dumb spirit, described as foaming and gnashing his teeth (Mark 9:17-18).",
            "Jesus lamented about the faithlessness of the generation and cast out the foul spirit (Mark 9:19-25).",
            "After the healing, Jesus returned the boy to his father (Mark 9:26-27).",
            "The disciples inquired about why they couldn’t cast out the spirit and learned that prayer and fasting are essential for such spiritual feats (Mark 9:28-29)."
        ],
        discussion_question: [
            {
                question: "What is fasting?",
                answer: ["Fasting is abstinence from food and drinks (Isaiah 58:3), pleasure (Amos 8:10), and social activities (Nehemiah 1:4)."]
            },
            {
                question: "What is prayer?",
                answer: ["Prayer is a means of drawing supernatural powers to address life's issues, releasing oneself to be strengthened by God, accessing God’s grace and blessings, engaging in spiritual fervency, and seeking divine intervention."]
            },
            {
                question: "What should we say about prayer and fasting?",
                answer: ["They are spiritual sacrifices that often yield good answers, ways to connect with God, opportunities to hear God more clearly, spiritual disciplines to grow, and methods to deny self-pleasures."]
            },
            {
                question: "What to do during prayer and fasting?",
                answer: ["Use the time for resting in God’s presence, listening to God, reading the Bible, planning extensively, and seeking guidance (Acts 13:2)."]
            }
        ],
        conclusion: "Prayer and fasting offer numerous privileges and opportunities. Embrace them to enhance your spiritual life and achieve transformative results."
    },
    {
        date: "SUNDAY 14TH JULY, 2024",
        lesson: "Lesson 2",
        topic: "The Altar of Private Prayer",
        text: "Leviticus 6:12 (KJV)",
        memory_verse: "Leviticus 6:13 - \"The fire shall ever be burning upon the altar; it shall never go out.\"",
        central_truth: "Praying in secret ceaselessly provides you testimonies in public consistently.",
        aim: "To encourage believers not to abandon the responsibility of engaging in private prayers.",
        introduction: "Read through the week's devotional for further understanding. Keeping the altar of private prayer alive means maintaining a fervent and consistent personal prayer life. This practice sustains intimacy with God and triggers victory over personal challenges.",
        main_point: [
            "The fire on the altar should always be burning, symbolizing the need for a constant and passionate prayer life (Leviticus 6:12).",
            "Maintaining unceasing prayer vigilance secures divine presence, protection, and inspiration (Leviticus 6:12).",
            "Burning wood every morning represents daily engagement with the Word of God, leading morning devotions (Leviticus 6:12).",
            "Laying the burnt offering in order signifies offering praises and thanksgiving to God.",
            "Burning the fat of peace offerings involves sharing testimonies to sustain peace and joy (Leviticus 6:12)."
        ],
        discussion_question: [
            {
                question: "What does an altar represent?",
                answer: ["An altar represents a place or occasion for personal encounters with God, which can also be established in our hearts."]
            },
            {
                question: "What’s the fire on the altar?",
                answer: ["It represents the zeal, passion, and fervency in our prayer life that protects and purifies us."]
            },
            {
                question: "How do you keep your altar of private prayer active and effective?",
                answer: ["Be consistent, persistent, and passionate in your prayers. Prepare to speak to God from your heart and approach Him with humility."]
            },
            {
                question: "What are the five-fold benefits of the private prayer altar?",
                answer: [
                    "Prayer Fire gives warmth: Fosters love and peaceful relationships.",
                    "Prayer Fire preserves: Protects from harm and maintains respect within the family.",
                    "Prayer Fire destroys and keeps away wild beasts: Shields from spiritual and physical harm.",
                    "The light of the fire offers direction: Provides guidance and counsel.",
                    "Prayer Fire Refines: Enhances personal growth spiritually, physically, and financially."
                ]
            }
        ],
        conclusion: "Maintaining a robust private prayer altar builds confidence and facilitates divine intervention. Like King Hezekiah, use your private prayer life to address issues and seek God’s aid."
    },
    {
        lesson: "Lesson 3",
        date: "SUNDAY 21ST JULY, 2024",
        topic: "GOD HEARS OUR PRAYERS",
        memory_verse: "Isaiah 43:26 - 'Put me in remembrance: let us plead together: declare thou, that thou mayest be justified.'",
        central_truth: "Heartfelt prayers can move God to change what He earlier said.",
        aim: "To teach believers that a negative verdict from God should be handled in prayers for a change to the better.",
        introduction: "Read the week’s devotional for more insight. You must dare to develop your personal prayer life. Because you will need it when you want to personally pray to God to change a negative verdict to a better outcome. There are certain challenges that, until you take it personal with God, no prophet or man can help you do it. You can see prophet Isaiah as God’s mouth piece received a message of Death for King Hezekiah. He didn’t intercede for him, until Hezekiah had to take it personal and prayed unto God with strong reasons and strong cry and God reversed the negative verdict for him. Develop the passion to take your matters personally to God in prayers.",
        main_point: [
            "That a man of God tells you something does not mean he has the final say.",
            "You have the right to pray, cry and plead God to have mercy on you.",
            "Hezekiah himself turned to God in heartfelt prayers and the same God gave another and better verdict.",
            "Just handle your matters directly and personally with God in prayers. He is not deaf; He will deliver and defend you."
        ],
        discussion_question: [
            {
                question: "Why was it important for God to send Prophet Isaiah to tell King Hezekiah that he will soon die?",
                answer: [
                    "God did so to elicit a response of faith from Hezekiah.",
                    "Hezekiah did not argue with Isaiah but turned to God in prayers to prove that his faith in God was genuine.",
                    "When God announces judgment, it is almost always an invitation to repent and receive mercy. Hezekiah understood this and acted promptly."
                ]
            },
            {
                question: "What kind of prayer is God quick to respond to?",
                answer:[ "Heartfelt prayers."]
            },
            {
                question: "What is a heartfelt prayer?",
                answer: [
                    "It is feeling sorrowful and showing remorse over an improper behavior or action.",
                    "This prayer is said not from the lips but from the depth of one’s heart."
                ]
            },
            {
                question: "Scriptural examples of heartfelt prayers include:",
                answer: [
                    "The prayer of the publican - Luke 18:10-18",
                    "The prayer of Hannah - 1 Samuel 1:13",
                    "The prayer of Eliezer, Abraham’s servant - Genesis 24:43-45",
                    "The prayer of David - Psalm 63:1, Psalm 119:43",
                    "The prayer of Jabez - 1 Chronicles 4:9-10"
                ]
            }
        ],
        conclusion: "Heartfelt prayers do always attract instant answers from God. May God give us the privilege to turn to Him through our heartfelt prayers."
    },
    {
        lesson: "Lesson 4",
        date: "SUNDAY 28TH JULY, 2024",
        topic: "FROM SORROW TO MORE HONOURABLE",
        text: "1 Chronicles 4:9-10",
        memory_verse: "Job 14:15 - 'Thou shalt call, and I will answer thee: thou wilt have a desire to the work of thine hands.'",
        central_truth: "In case your life is in the wrong direction, go to God in prayer for a change of story.",
        aim: "To let believers know that no matter how things are with them, by prayer and fasting, a change is possible.",
        introduction: "Read the week’s devotional. There is a better version to the level of life you are having now. Sit back and examine your life where there is need for a change; do not fold your hands and watch things still going in the wrong direction. Rather, go to God in prayers, and He will lead you into a far better and more honorable version of your life. Also, if you have a name that has no profitable meaning or one that is negative, please, as a matter of necessity and urgency, change it or I pray the Holy Spirit helps you change it.",
        main_point: [
            "The picture of a better future is revealed by the shadow of an earlier experience.",
            "His mother pronounced sorrow upon Jabez through the name she gave to him.",
            "When nothing seems to work for you, work on your prayer life.",
            "Prayer is the secret of an ever-winning life."
        ],
        discussion_question: [
            {
                question: "What is one quality in the life of Jabez that we all should emulate?",
                answer: ["Jabez never allowed his name to control his destiny in the wrong direction; he prayed his life to the right direction."]
            },
            {
                question: "Where was Jabez’s prayer point taken from in the Bible?",
                answer: ["Genesis 1:28 - 'And God blessed them, and God said unto them; Be fruitful, and multiply, and replenish the earth, and subdue it; and have dominion over the fish of the sea, and over the fowl of the air, and over every living thing that moveth upon the earth.'"]
            },
            {
                question: "Comparing 1 Chronicles 4:9-10 with Genesis 1:28, what did Jabez pray for?",
                answer: [
                    "Blessing",
                    "Enlargement",
                    "Preservation",
                    "Dominion"
                ]
            },
            {
                question: "Whose prayer is also similar to Jabez's?",
                answer: ["Jacob’s prayer - Genesis 32:24-30. This involved a change of name and a change of his life’s story."]
            },
            {
                question: "What other lessons can we learn from this SUNDAY school topic?",
                answer: [
                    "Gain clarity about what you are named and how you name your children.",
                    "Like Jabez and Jacob, build a power base for yourself through your prayer life.",
                    "Develop the ability through your prayers to subdue your environment or territory.",
                    "Don’t be afraid to step up for a blessing, even if you have to stand alone."
                ]
            }
        ],
        conclusion: "One thing that no one must misuse is the opportunity to pray and get your condition changed for the better. This is what the prayers of Jabez and Jacob have taught us."
    },
    {
        lesson: "Lesson 5",
        date: "SUNDAY 4TH AUGUST, 2024",
        topic: "GOD’S LOVE IS BEYOND MEASURE",
        text: "Zephaniah 3:14-20",
        memory_verse: "Zephaniah 3:17 - “The Lord thy God in the midst of thee is mighty; He will save, He will rejoice over thee with joy, He will rest in His love, He will joy over thee with singing.”",
        central_truth: "God’s love is a resting place for our weary souls.",
        aim: "To make believers know that it is in God’s love that we can find comfort and peace.",
        introduction: "Despite the chaos and noise in the world today, God’s love is a constant refuge—a shelter from danger or distress. It is a sanctuary where we find solace and rejuvenation. Zephaniah 3:14-20 shows us that His love is a safe haven for rest and restoration. Indeed, God’s love for us is beyond measure.",
        main_points: [
            "God’s Love and Joy: God’s love cheers us into singing, rejoicing, and gladness because we shall not see evil anymore (Zeph. 3:14-15).",
            "God’s Presence in Trials: In our trials and challenges, He assures us of His unwavering presence (Zeph. 3:16-17).",
            "God’s Joy and Blessings: God’s love not only saves us but also rejoices over us with immense joy and will give us praise and fame (Zeph. 3:18-19).",
            "Living in God’s Love: Dwelling in His love fills our lives with gratitude, praise, and turnaround from captivity (Zeph. 3:20)."
        ],
        discussion_question: [
            {
                question: "How has God assured us of His love towards us without measure?",
                answer: [
                    "He promises to remain mighty and powerful for us amid trials and challenges.",
                    "He will be intimately involved in our journey through life.",
                    "He will rescue us from despair."
                ]
            },
            {
                question: "What must we do so that God will keep finding joy in our lives?",
                answer: [
                    "Walk in His ways and experience His blessings.",
                    "Dwell in His presence and let His love permeate every aspect of our lives.",
                    "Respond with gratitude and praise.",
                    "Align ourselves with His will and surrender to His plans.",
                    "Make a difference in our spheres of influence.",
                    "Reflect His love and truth to those around us."
                ]
            }
        ],
        conclusion: "Let us walk in obedience, seeking His guidance and relying on His strength. God’s love will keep flowing to us. Thank you, O Lord, for Your constant love and unwavering commitment to me. Amen."
    },
    {
        lesson: "Lesson 6",
        date: "SUNDAY 11TH AUGUST, 2024",
        topic: "EXCEEDING ABUNDANTLY ABOVE ALL",
        text: "Ephesians 3:14-21",
        memory_verse: "Ephesians 3:20 - “Now unto him that is able to do exceeding abundantly above all that we ask or think, according to the power that worketh in us.”",
        central_truth: "No matter how dire our circumstances may be, God is able to do or go beyond our wildest imagination or request.",
        aim: "To remind believers of the power and ability of God to do exceeding abundantly above all that we ask or think.",
        introduction: "Exceeding abundantly above all refers to a superlative level of lifting and expansion. 'Exceeding' means going beyond limits, 'abundantly' signifies massive size and surplus, and 'above' denotes moving to a higher level. In this year of lifting, God has the intention and capacity to elevate you or your endeavor to the zenith.",
        discussion_question: [
            {
                question: "What role are we (Christians) to play to trigger this superlative lifting promised by God?",
                answer: [
                    "Keep thanking Him for His promises until they are fulfilled.",
                    "Surrender our circumstances to Him.",
                    "Invite His divine power to work in us and through us.",
                    "Seek His help to stay in faith and step up our service.",
                    "Trust in His provision spiritually, financially, and politically.",
                    "Continue to weather life’s storms until God’s glory manifests."
                ]
            },
            {
                question: "How will this 'exceeding abundantly above all' realm manifest in our lives?",
                answer: [
                    "Through positive results.",
                    "Lifting experiences.",
                    "Enabling environment.",
                    "Activated affections or affiliations.",
                    "Sumptuous financial and nutritional provision.",
                    "Added advantages.",
                    "Numerous testimonies and termination of evil plans."
                ]
            },
            {
                question: "How will we sustain ourselves on this exalted level?",
                answer: [
                    "Engage in positive confessions.",
                    "Maintain holiness and a regulated prayer schedule.",
                    "Clear our hearts of grudges and malice.",
                    "Practice gratitude and generosity."
                ]
            }
        ],
        conclusion: "Celebrate Jesus ceaselessly and murmur less."
    },
    {
        lesson: "Lesson 7",
        date: "SUNDAY 18TH August, 2024",
        topic: "GROW YOUR FAITH",
        text: "Romans 10:10-17",
        memory_verse: "Luke 17:5 - “And the Apostles said unto the Lord, Increase our faith.”",
        central_truth: "Your faith is like a seed; you have to water and nurture it to grow.",
        aim: "To let believers know that faith is not static, but rather exists in degrees - no faith, little faith, and greater faith.",
        introduction: "At the new birth, every Christian receives a measure of faith (Rom. 12:3). Just as initial prayers are answered promptly, lack of growth in faith can lead to struggles where there were once victories. To overcome this, believers must grow their faith continually.",
        main_point: [
            "Faith is a matter of the heart, not the head, and is expressed through the mouth (Rom. 10:10).",
            "Faith will not bring you shame (Rom. 10:11).",
            "Faith works for everyone, regardless of tribe or tongue (Rom. 10:12).",
            "The spoken or written word triggers faith (Rom. 10:13).",
            "To produce desired results, one must labor to understand the word of God."
        ],
        discussion_question: [
            {
                question: "What faith is not:",
                answer: [
                    "Faith is not an ideology; it is a tangible force (Mark 5:25-34).",
                    "Faith does not bring insult; it brings results (Heb. 11:1-2).",
                    "Faith is not just a mental exercise but a matter of the heart (Rom. 10:9).",
                    "Faith is not merely believing God can act; it is acting on His word and expecting Him to perform (Mark 9:23; 10:27).",
                    "Faith is not vague; it is substantial and evidential (Heb. 11:1)."
                ]
            },
            {
                question: "What is Faith?",
                answer: [
                    "Faith is a spiritual force that moves God's hand in your favor (Heb. 11:1).",
                    "It is the ability to believe in God's work and recognize the reality beyond physical sight.",
                    "Faith is the invisible confidence that something exists beyond present sight.",
                    "It is partnering with the invisible God according to the scriptures, committing His integrity to perform what He has spoken.",
                    "Faith is the essence of your destiny."
                ]
            },
            {
                question: "How to grow your Faith:",
                answer: [
                    "Continue hearing the word of God repeatedly (Rom. 10:17).",
                    "Meditate on the scriptures (Joshua 1:8).",
                    "Associate with faith giants, like Caleb and Joshua (Num. 13:30).",
                    "Avoid complainers and negative influences (2 Thess. 3:14).",
                    "Surround yourself with people whose words increase your faith (Prov. 27:17).",
                    "Speak to create the outcomes you desire (Heb. 11:3)."
                ]
            },
            {
                question: "What are the benefits of Faith?",
                answer: [
                    "It delivers your inheritance (Heb. 11:2).",
                    "It guarantees victory (1 John 5:4).",
                    "It prevents the execution of wicked plans (Eph. 6:16).",
                    "It connects you with the miraculous (Acts 9:33-34).",
                    "It makes things possible (Mark 9:24).",
                    "It provides rest (Heb. 4:3-4).",
                    "Your eternal life depends on faith in Jesus (John 3:16)."
                ]
            }
        ],
        conclusion: "Faith is crucial for receiving God's promises and transforming negative reports into positive ones. Building and growing your faith is essential for achieving victory and experiencing God's blessings."
    },
    {
        lesson: "Lesson 8",
        date: "SUNDAY 25TH August, 2024",
        topic: "CONTINUALLY SEEK TO HONOUR GOD",
        text: "Genesis 39:4-12",
        memory_verse: "1 Samuel 2:30 - “Wherefore the Lord God of Israel said, I said indeed that thy house, and the house of thy father, should walk before me forever but now the Lord said, Be it far from me; for them that honour me I will honour, and they that despise me shall be lightly esteemed.”",
        central_truth: "Until you continually seek to honour God, you will not become honourable in life.",
        aim: "To let believers know that a person who reverences God will become a point or person of reference in life.",
        introduction: "In God’s agenda for man, honour is reciprocal (1 Samuel 2:30). Prophet Eli started well by honouring God but later honoured his sons above God, leading to God withdrawing His promises. Similarly, we should strive to honour God throughout our lives. Joseph, as depicted in the text, continuously honoured God and, in turn, was made more honourable than his peers.",
        main_point: [
            "Joseph served Potiphar and was made overseer of his household; God blessed Potiphar's house for Joseph's sake (Gen. 39:4-6).",
            "Potiphar’s wife desired Joseph and attempted to seduce him, but Joseph refused (Gen. 39:7-9).",
            "Joseph fled from the woman’s advances, demonstrating his deep honour and fear of God (Gen. 39:10-12)."
        ],
        discussion_question: [
            {
                question: "What is the meaning of honour?",
                answer: [
                    "To show respect, appreciation, or affection for someone with a public celebration.",
                    "To hold somebody in high esteem.",
                    "To refuse to rebel against someone higher in rank or authority.",
                    "To reverence someone in a position of authority."
                ]
            },
            {
                question: "In what ways did Joseph prove that he honours God?",
                answer: [
                    "His life was a testament to God's glory (Gen. 39:9).",
                    "He demonstrated reverence towards God in his public speeches (Gen. 41:16) and private actions (Gen. 39:7-9).",
                    "He showed respect for hierarchy (Gen. 39:9).",
                    "He maintained a good conscience and adhered to integrity (Gen. 39:6).",
                    "He honored his boss and authority (Prov. 29:2)."
                ]
            },
            {
                question: "Which other ways can one honour God?",
                answer: [
                    "With our substance (Prov. 3:9-10).",
                    "With our first fruits (Prov. 3:9-10).",
                    "By doing what pleases God (Prov. 16:7).",
                    "By our faith (Heb. 11:6)."
                ]
            },
            {
                question: "What are the benefits of honouring God?",
                answer: [
                    "When you honour God, God honours you (1 Sam. 2:30).",
                    "God grants you a flawless prophetic record (Gen. 41:13, Gen. 41:16; Dan. 2:19).",
                    "God fills your endeavours with abundant profit and new opportunities (Prov. 3:9).",
                    "If you shift honour from God, He will shift His benefits away from you (1 Sam. 2:29)."
                ]
            }
        ],
        conclusion: "Continually seeking to honour God is essential for receiving His blessings and achieving high dignity and respect in life. Until you show respect for heavenly hierarchy, you will not rise to a position of great honour and authority."
    },
    {
        lesson: "Lesson 9",
        date: "SUNDAY 1ST September, 2024",
        topic: "KINDNESS BEGETS KINDNESS",
        text: "Joshua 2:1-22",
        memory_verse: "Joshua 2:12 - “Now therefore, I pray you, swear unto me by the Lord, since I have shewed you kindness, that ye will also shew kindness unto my father’s house, and give me a true token.”",
        central_truth: "Kindness should never be rewarded with wickedness.",
        aim: "To teach people to be kind to others always, so as to enjoy kindness also.",
        introduction: "In a world where wickedness often prevails, kindness is a timely and necessary virtue. It involves treating people with love, respect, and finding opportunities to do good for others. Kindness is characterized by good-heartedness, warm-heartedness, and the ability to overlook others' flaws.",
        main_point: [
            "Joshua sent two men to spy Jericho, and the men of the city sought to kill them, but Rahab saved the spies (Josh. 2:1-3).",
            "Rahab hid the men on her rooftop and did not reveal their location (Josh. 2:2).",
            "She requested that the spies show kindness to her and her family in return (Josh. 2:12-17).",
            "The spies instructed Rahab to tie a scarlet thread in her window for her household's rescue, and she let them down by the window (Josh. 2:18-22)."
        ],
        discussion_question: [
            {
                question: "What are the habits that do not reflect kindness?",
                answer: [
                    "Bitterness (angry at people).",
                    "Callousness (no sympathy).",
                    "Unkindness (not friendly).",
                    "Hardheartedness (no human kindness).",
                    "Harassment (treating people wrongly).",
                    "Cruelty (no mercy).",
                    "Unfeelingness (no empathy)."
                ]
            },
            {
                question: "What key lessons can we learn from the harlot Rahab?",
                answer: [
                    "Her faith in God led her to save the spies and avoid perishing with the unbelievers in Jericho (Heb. 11:31).",
                    "She pleased God by not conspiring with the people of Jericho to kill the spies (Josh. 2:1).",
                    "Rahab was justified by her works (James 2:25).",
                    "Her actions illustrate that kindness begets kindness (Josh. 6:25; Josh. 2:6).",
                    "Rahab's betrayal of Jericho is a testament to her faith in the God of Israel (Josh. 2:9).",
                    "She was courageous in protecting the spies based on God's miracles and sought to save herself and her family (Josh. 2:12).",
                    "Biblical interpreters view Rahab as a model of hospitality, mercy, faith, patience, and repentance in her interaction with the spies."
                ]
            },
            {
                question: "What are examples of acts of kindness in the Bible?",
                answer: [
                    "Rebekah (Gen. 24:15,19).",
                    "The Good Samaritan (Luke 10:34).",
                    "A young man of Egypt (1 Sam. 30:15-16).",
                    "Lydia (Acts 16:15)."
                ]
            },
            {
                question: "Who did not return kindness for kindness?",
                answer: [
                    "Nabal (1 Sam. 25:2-10, 18, 32-33).",
                    "Nabal benefited from David’s protection but refused to offer food when requested, though his wife Abigail later provided."
                ]
            },
            {
                question: "How can we show kindness today?",
                answer: [
                    "Feed the hungry (Matt. 25:35-36).",
                    "Clothe the naked.",
                    "Forgive the guilty.",
                    "Welcome the unwanted.",
                    "Care for the ill.",
                    "Love your enemies.",
                    "Do unto others as you would have them do unto you (Matt. 7:12).",
                    "Avoid doing to others what angers you if done to you by others."
                ]
            },
            {
                question: "What are examples of kind acts?",
                answer: [
                    "A smile.",
                    "A nice word.",
                    "An unexpected deed.",
                    "A planned surplus."
                ]
            },
            {
                question: "What are the effects of acts of kindness?",
                answer: [
                    "We make people feel good.",
                    "We pass along hope.",
                    "We promote peace.",
                    "We show people that we care."
                ]
            }
        ],
        conclusion: "Kindness involves prioritizing others' needs and can be as simple as giving up our seat on a bus to someone who needs it more."
    },
    {
        lesson: "Lesson 10",
        date: "SUNDAY 8TH September, 2024",
        topic: "BE KIND TO ONE ANOTHER",
        text: "Ephesians 4:29, 32",
        memory_verse: "Matt. 5:7 - “Blessed are the merciful; for they shall obtain mercy.”",
        central_truth: "Until we are kind one to another, we will not work good for each other.",
        aim: "To make believers show love and kindness to one another.",
        introduction: "A man who is kind does good to himself because kindness often returns. The principle of mercy is clear: showing mercy results in receiving mercy. Expressing kindness through words and deeds helps one another, offering wisdom and new ideas.",
        main_point: [
            "Kindness should start with our words and extend to our deeds (Eph. 4:29a).",
            "Our speech should be good and edifying (Eph. 4:29b).",
            "Our words should minister grace to the hearers (Eph. 4:29c).",
            "We should be kind and forgiving towards one another (Eph. 4:32)."
        ],
        discussion_question: [
            {
                question: "What is kindness?",
                answer: [
                    "Kindness is the quality of being friendly, generous, and considerate.",
                    "It involves affection, gentleness, warmth, care, and concern.",
                    "Kindness is more than outward behavior; it includes harboring a helpful spirit, being generous, doing things without expecting returns, and solving problems at little or no cost."
                ]
            },
            {
                question: "How is kindness demonstrated in the Bible?",
                answer: [
                    "The Good Samaritan shows love for enemies and doing good to others.",
                    "Ruth demonstrated immense kindness to her mother-in-law by accompanying her to her homeland.",
                    "David showed kindness to Jonathan’s son due to his friendship with Jonathan."
                ]
            },
            {
                question: "What does it mean to 'be kind one to another'?",
                answer: [
                    "Being selfless.",
                    "Caring.",
                    "Compassionate.",
                    "Generous.",
                    "Unconditionally helpful or useful to others."
                ]
            },
            {
                question: "How is kindness expressed in words?",
                answer: [
                    "Compliments and affirmations such as 'I love the way you think' (Col. 4:6), 'You are creative' (Lk. 6:31), 'You are as beautiful as you are' (Prov. 16:24), 'You make me smile' (2 Sam. 9:7), 'I am proud of you' (Prov. 12:25), 'We are so favored that you’re a part of our family' (Prov. 11:17), and 'Always remember that I believe in you' (Matt. 7:12)."
                ]
            },
            {
                question: "Does kindness in words play a role in soul winning? How?",
                answer: [
                    "Yes, kindness in words is crucial for soul winning.",
                    "A kind word can unlock unbelieving hearts and facilitate conversion.",
                    "It inspires friendship, encourages fellowship, and attracts cooperation.",
                    "Kind words can endear someone to your faith and make them more receptive to the gospel.",
                    "A smile and kind words can also draw attention and open doors for sharing the message of Christ."
                ]
            }
        ],
        conclusion: "We should extend our kindness to unbelievers to win them for Christ and invite them to Church."
    },
    {
        lesson: "Lesson 11",
        date: "SUNDAY 15TH September, 2024",
        topic: "TITHES AND OFFERINGS",
        text: "Malachi 3:8-12",
        memory_verse: "Malachi 3:8 - “Will a man rob God? Yet ye have robbed me. But ye say, wherein have we robbed thee? In tithes and offerings.”",
        central_truth: "Our lifting is tied to our positive response to tithes and offerings.",
        aim: "To teach people that our tithes and offerings will open Heaven in our favor and keep us from suffering.",
        introduction: "Read the week’s devotional for more understanding. Despite people around the world paying their tithes and giving offerings, some still do not receive the financial blessings promised in scripture. This lesson explores why and how our response to tithes and offerings impacts our blessings.",
        main_point: [
            "God complains that we have robbed Him in tithes and offerings.",
            "We are commanded to bring all tithes to God and let Him prove Himself as a supplier of blessings beyond abundance (Vs. 10).",
            "God will rebuke the devourer for the sake of tithers, preventing hindrances to finances, favors, harvests, and excesses.",
            "Obeying God in tithes and offerings leads to abundant blessings and makes us amiable people."
        ],
        discussion_question: [
            {
                question: "How do we rob God in tithes and offerings?",
                answer: [
                    "By paying less than 10% or not paying our tithes at all.",
                    "By being irregular in tithes and offerings.",
                    "By not honoring Him with our finances."
                ]
            },
            {
                question: "Are tithes and offerings the same? If not, what are the differences?",
                answer: [
                    "Tithes are not the same as offerings.",
                    "Tithe is 10% of a person’s income or increase, while offering is a discretionary amount determined by the giver (2 Cor. 9:7).",
                    "Unlike tithes, there is no set amount or percentage for offerings.",
                    "Tithe opens financial doors of favor from God and man.",
                    "An offering is a seed for reaping a harvest (Gal. 6:7).",
                    "Tithes represent strict obedience and trustworthiness, while offerings are expressions of love and gratitude.",
                    "Tithes establish a trust relationship with God, whereas offerings reflect the depth of your love for Him."
                ]
            },
            {
                question: "What are some benefits of tithing?",
                answer: [
                    "Sponsors welfare in the church (Mal. 3:10).",
                    "Opens financial doors outside the church.",
                    "Serves as a defense to our business and labor (Mal. 3:11).",
                    "Speaks for us and helps us win battles in life, both physically and spiritually."
                ]
            }
        ],
        conclusion: "Tithes and offerings are routes to financial peace. Without peace in your finances, your life will remain fragmented."
    },
    {
        lesson: "Lesson 12",
        date: "SUNDAY 22ND September, 2024",
        topic: "BE AN EFFECTIVE SOUL WINNER",
        text: "Acts 8:26-40",
        memory_verse: "Romans 5:8 - “But God commendeth his love towards us, in that while we were yet sinners, Christ died for us.”",
        central_truth: "Follow divine leading to be an effective soul winner.",
        aim: "To reach people and use every opportunity to preach and lead sinners to repentance and water baptism.",
        introduction: "To some people, the act of soul winning is not taught but caught through revelation or divine prompting. People like Philip the Evangelist and Paul the Apostle exemplify this divine burden. Most Christians need to understand that being a follower of Jesus involves being a fisher of men (Matt. 4:19). This lesson aims to teach and inspire Christians to actively pursue soul winning.",
        discussion_question: [
            {
                question: "What should be the basis of our message?",
                answer: [
                    "God’s love towards us and how we need to reciprocate His love by yielding our lives to walk with Him, serve Him, and testify His love, goodness, and mercy to others (John 3:16, Romans 5:8).",
                    "Understanding that Jesus’ sacrifice and death on the cross should not be in vain (Romans 5:8; Galatians 2:21; 1 Corinthians 15:14, 17, 58; 2 Corinthians 6:1)."
                ]
            },
            {
                question: "What are the proven methods to be an effective soul winner?",
                answer: [
                    "Intentional method: Ask God to give you an Evangelistic burden for perishing souls and opportunities to reach them for Christ.",
                    "Lifestyle method: Live a consistent Christian life (Matt. 5:14-16). Demonstrate integrity, authentic faith, love, forgiveness, and trust.",
                    "Friendship approach: Build relationships with those needing Christ, following Jesus’ example with Zacchaeus.",
                    "Groom yourself in the word (2 Timothy 2:15): Memorize scriptures and share them. Examples include Romans 3:23, Romans 6:23, Romans 10:9-10, 13, and 1 John 5:1, 13.",
                    "Be ready to preach to someone, like Philip (Acts 8:26-40) and Peter (1 Peter 3:15).",
                    "Create opportunities: Invite someone to church, share tracts, handbills, etc., and impress upon them the need for Christ.",
                    "Fulfill your part, and God will do His part. Preach the word, but only God can convert the soul (John 12:32)."
                ]
            }
        ],
        conclusion: "We are not expected to be perfect, only Christ was sinless. However, we must have a growing, maturing Christian life that others can recognize and respect. Let our light so shine."
    },
    {
        lesson: "Lesson 13",
        date: "SUNDAY 29TH September, 2024",
        topic: "FEAR GOD: A RULE OF LIFE",
        text: "Luke 12:4-5, 16-21",
        memory_verse: "Ecclesiastes 12:13 - “Let us hear the conclusion of the whole matter: Fear God and keep his commandments: for this is the whole duty of man.”",
        central_truth: "Until we fear God, God cannot keep us going strong, healthy, and hearty in life.",
        aim: "To encourage God’s people to fix their faith and reverential fear on God for exploits in life.",
        introduction: "It is absolutely necessary to fear God as the ruler of life in heaven and earth. When we take this as a responsibility and our duty due to God, He will help us enjoy all time possibilities in life.",
        main_point: [
            "We are to fear God because He has the power to kill and cast us into hell (Luke 12:4-5).",
            "In the parable of the rich fool, the man had no time to fear God or plan his ways along with God. For that reason, God took his life and cast him into hell (Luke 12:16-21)."
        ],
        discussion_question: [
            {
                question: "What is the fear of God?",
                answer: [
                    "Having reverence for God.",
                    "Having no hidden intention to keep Him outside life and plans.",
                    "Acknowledging Him in all our ways.",
                    "Giving Him first place in our lives."
                ]
            },
            {
                question: "What did the Rich man not know?",
                answer: [
                    "He did not realize that it was God who made his ground yield plentifully, not his own strength (Luke 12:16).",
                    "He knew he had enough and to spare but didn’t understand that the surplus should be given to those who had nothing (Luke 12:17).",
                    "He did not understand that selfishness and self-centeredness are wrong (Luke 12:18).",
                    "He did not know how to acknowledge God for the expansion of his business.",
                    "He had no time to give thanks to God."
                ]
            },
            {
                question: "What is ‘fear not’?",
                answer: [
                    "‘Fear not’ means to have more faith.",
                    "Lack of faith leads to more fear.",
                    "To avoid harboring fear in our lives, we are advised to ‘fear not’ and shun fear."
                ]
            },
            {
                question: "What are possibly the reasons we are being asked to ‘fear not’?",
                answer: [
                    "A moral advice (Ruth 3:11).",
                    "A safety tip (1 Samuel 22:23).",
                    "A word of prophecy (1 Samuel 23:17).",
                    "A promise of restoration (2 Samuel 9:7).",
                    "A spur for a miracle (1 Kings 17:13).",
                    "A boost of confidence (2 Kings 6:16).",
                    "A promise of divine help (Isaiah 41:13)."
                ]
            },
            {
                question: "What is the whole duty of man?",
                answer: "The whole duty of man is to fear God and keep His commandments."
            }
        ],
        conclusion: "Until you fear God, other creatures and situations on earth will not fear you."
    },
    {
        lesson: "Lesson 14",
        date: "SUNDAY 6TH October, 2024",
        topic: "HOLD FAST THAT WHICH IS GOOD",
        text: "I Thess. 5:16-24",
        memory_verse: "I Thess. 5:24 - “Faithful is he that calleth you, who also will do it.”",
        central_truth: "When you hold fast to that which is good, you are bound to rise to a higher height of greatness in life.",
        aim: "To give believers practical instructions that will enable them to gain and sustain relevance in their Christian walk.",
        introduction: "“Hold fast that which is good” is the motto of Methodist Boys’ High School, Oron, Akwa Ibom State, Nigeria. This phrase has triggered excellence and launched people into prominence in governance, ministry, politics, academics, and business who have passed through the school. I believe this was also the intention of Paul the Apostle when he exhorted the Thessalonian Christians to “prove all things, hold fast that which is good” (I Thess. 5:21). By this lesson, he is also extending the advice to the church of this dispensation and generation.",
        main_point: [
            "Paul the Apostle gives a spiritual code of conduct that will ever remain to fetch Christians victory and success in their walk with God.",
            "These include: continuous rejoicing, prayers, giving thanks, and a fervent spirit - Vs. 16-19.",
            "He also warns them against despising prophesying, failure to prove all things, and indulging in evil practices. For God will sanctify, preserve, and back them to succeed in the end."
        ],
        discussion_question: [
            {
                question: "What does it mean to ‘hold fast that which is good’?",
                answer: [
                    "It is an exhortation to hold to Christian standards without any intention of deviating.",
                    "It is an encouragement to persevere through persecution and temptation in the course of discharging our duties or responsibilities to God.",
                    "It is a command to resist following false teachings and fake prophesying or the spirit of anti-Christ.",
                    "It is an inspirational counsel to keep pleasing God, even if our faith and character are under attack."
                ]
            },
            {
                question: "What are these Christian standards?",
                answer: [
                    "Rejoice evermore.",
                    "Pray without ceasing.",
                    "Give thanks constantly.",
                    "Quench not the spirit.",
                    "Despise not prophesying.",
                    "Prove all things, hold fast that which is good.",
                    "Abstain from all appearances of evil."
                ]
            },
            {
                question: "Why is keeping to these Christian standards or spiritual code of conduct necessary?",
                answer: [
                    "We are not to serve God sorrowfully and lose the presence of God and His right hand working out things for our good and pleasure (opposite of Ps. 16:11).",
                    "We are not to stay prayerless and become a prey to the devil and be killed by the ‘Herods’ of this world (Acts 12:1-3).",
                    "Our thanklessness and joylessness will pitch God against us (Deut. 28:47-48).",
                    "If we quench the spirit, we’ll grieve the Holy Spirit and run out of Divine help (opposite of Rom. 8:26).",
                    "If we despise prophesying, we will lack edification.",
                    "If we don’t prove all things, we’ll be carried about by every wind of doctrine.",
                    "If we don’t abstain from all appearances of evil, we will not be able to keep a date with destiny (compare Samson, Judges 16:18-20, 28-30)."
                ]
            }
        ],
        conclusion: "When we hold fast that which is good, God hides us from attacks and persecutions that destroy life. He also watches over our involvement in God’s work till He rewards us."
    },
    {
        lesson: "Lesson 15",
        date: "SUNDAY 13TH October, 2024",
        topic: "A mandate to speak God’s word",
        text: "Luke 12:11-15",
        memory_verse: "Luke 12:12 - “For the Holy Ghost shall teach you in the same hour what ye ought to say.”",
        central_truth: "Key into speaking the word that God puts in your mouth and every mountain before you shall become a plain land.",
        aim: "To let believers know that God’s word put in their mouths or placed on their minds has the power to achieve the impossible.",
        introduction: "God’s words programmed into our mouths have the capacity to open closed doors. They have the tendency to turn unwilling minds to yielding ones and the ability to help us accomplish tasks in an uncommon manner. The Holy Spirit is the major channel that God uses to lay His word in our mouths. Reading through this week’s devotional will provide additional help.",
        main_point: [
            "When you are brought before hypocrites, don’t worry; God will give you the right words to answer them – Vs.11-12.",
            "Jesus showed an example of how to answer hypocrites/unfriendly friends – Vs. 13-14.",
            "Jesus warns that a man’s life is not sustained by his possessions."
        ],
        discussion_question: [
            {
                question: "What is a mandate?",
                answer: [
                    "An authorization to act, given to a representative.",
                    "The right God has given to His servants to minister to people’s needs on His behalf.",
                    "The secret backing of God to His servants and children to succeed when it seems like God’s name and their faith are going to be ridiculed."
                ]
            },
            {
                question: "Why the mandate to speak God’s word?",
                answer: [
                    "To serve as God’s oracle.",
                    "The right to speak and demand from Heaven to act in our favor.",
                    "To call forth God to heal, provide, and protect people from harm and receive God's response."
                ]
            },
            {
                question: "What is God’s word capable of doing?",
                answer: [
                    "Teaches us what to say.",
                    "Fuels how to speak.",
                    "Puts words in our mouths.",
                    "Guides our utterances.",
                    "Operates through channels.",
                    "Triggers Holy Ghost Response.",
                    "Guides mouth and wisdom."
                ]
            },
            {
                question: "Without God’s word, what do we face?",
                answer: [
                    "Ignorance.",
                    "Confusion.",
                    "Loss of words.",
                    "Disorderly utterance.",
                    "No link to Divine instructions.",
                    "Loss of Holy Ghost’s help.",
                    "Silence and foolishness."
                ]
            },
            {
                question: "Those who depended on God’s word to carry out their assignments:",
                answer: [
                    "Moses – Exo. 4:2.",
                    "Isaiah – Isa. 50:4.",
                    "Jeremiah – Jer. 1:9.",
                    "The 12 Apostles of Jesus – Mat. 10:19."
                ]
            },
            {
                question: "Benefits of God’s word:",
                answer: [
                    "Defends us.",
                    "Counsels us.",
                    "Gives us dominion in the midst of our enemies.",
                    "Gives us the privilege to defeat our enemies.",
                    "Gives us the grace to become more than conquerors."
                ]
            }
        ],
        conclusion: "The best thing we can always do for ourselves in this Christian walk is to continually yield to God’s word. God’s word will always work out things for our good and joy."
    },
    {
        lesson: "Lesson 16",
        date: "SUNDAY 20TH October, 2024",
        topic: "THE LORD IS COMPASSIONATE",
        text: "Psalm 103:1-5; Isa. 38:1-5",
        memory_verse: "Isaiah 38:5 - “Go, and say to Hezekiah, thus saith the Lord, the God of David thy father, I have heard thy prayer, I have seen thy tears: behold, I will add unto thy days fifteen years.”",
        central_truth: "God’s compassion can sponsor your life’s elongation.",
        aim: "To show believers how to draw compassion from God through their prayer life.",
        introduction: "Ensure you go through this week’s devotional. Two great kings in the Bible proved that the Lord is compassionate. They did this, at different times and unknown to each other, by their humility and prayer life. They are David and Hezekiah. Beloved, by your humility and prayer life you can win the sympathy of a compassionate God in times of difficulty or near calamity and even at moments of uncertainty.",
        main_point: [
            "David blessed and thanked the Lord for:",
            "Forgiving his iniquities.",
            "Healing all his diseases.",
            "Crowning him with loving kindness.",
            "Granting him tender mercies.",
            "Redeeming his life from destruction.",
            "Satisfying his mouth with good things.",
            "Renewing his youth like the eagle’s.",
            "God reversed the death sentence with fifteen extra years of life for Hezekiah through Isaiah’s voice."
        ],
        discussion_question: [
            {
                question: "What is compassionate?",
                answer: [
                    "Being sympathetic or feeling pity for someone.",
                    "Being conscious of someone’s distress and willing to help out.",
                    "Being sensitive to someone’s need and being ready to provide it."
                ]
            },
            {
                question: "What is the meaning of: The Lord is compassionate?",
                answer: [
                    "God is kind, good-hearted, and merciful.",
                    "God is moved by our tears, pleadings, and prayers and is willing to bring us joy and peace.",
                    "God is sensitive to our suffering and ready to alleviate it.",
                    "He uses His love and kindness to wipe away tears and keep us from sorrowing."
                ]
            },
            {
                question: "How did (a) David and (b) Hezekiah attract God’s compassion?",
                answer: [
                    "David:",
                    "David killed Uriah and took his wife Bathsheba (2 Sam. 12:9), and David was to die also.",
                    "David was prompt to show remorse, fast, pray, confess his sins, and plead with tears for God’s mercy and compassion (Psalm 51:1-2,5,9).",
                    "God did not kill David, although the child born by Uriah’s wife died (2 Sam. 12:13-20).",
                    "Hezekiah:",
                    "He turned his face to the wall and prayed unto God – Isa. 38:3.",
                    "He reminded God of how he had walked before the Lord in truth and with a perfect heart and had done good in His sight – Isa. 38:3.",
                    "Hezekiah wept sore – Isa. 38:3, and God reversed the death sentence – Isa. 38:5."
                ]
            },
            {
                question: "Why did God show them compassion?",
                answer: [
                    "Their responses gave God strong reason to do so (Isa. 41:21).",
                    "Hezekiah’s lineage linked to David – Isa. 38:5.",
                    "Because of God’s covenant with David and his sons – 2 Chron. 13:5."
                ]
            }
        ],
        conclusion: "God is ready to show His compassion to His children who are covenantally linked to David. David pleased Him with his attitude of remorse and plea for forgiveness. Let us strive to please God by cultivating a genuine attitude of humility and seeking His compassion through heartfelt prayer."
    },

    {
        lesson: "Lesson 17",
        date: "SUNDAY 27TH October, 2024",
        topic: "THE FRIENDSHIP OF JONATHAN AND DAVID",
        text: "I Samuel 18:1-5; 19:1-4",
        memory_verse: "Hebrews 7:7 - “And without all contradiction the less is blessed of the better.”",
        central_truth: "Until you have a destiny helper, your life cannot get better.",
        aim: "To encourage believers to pray and seek for destiny helpers.",
        introduction: "Read the week’s devotional for more understanding. God created things in twos – for example, male and female (Gen. 1:27). He does not want any man or creature to operate alone. He Himself never operated alone when He said: 'Let us make man in our image, after our likeness.' (Gen. 1:26). The 'us' refers to Jesus and the Holy Spirit. They are in relationship with Him. Notice this: He created other things alone (Gen. 1:3-25). You need another person to encourage, defend, inspire, and cooperate with you to accomplish tasks in life. Like David, you need a Jonathan to defend or give you safety hints when attempts are being made to cut short your life.",
        main_point: [
            "This was a divine plan:",
            "The soul of Jonathan was knit with the soul of David, and Jonathan loved David as his own soul – verse 1.",
            "King Saul’s heart also knit with the heart of David (God had clothed David with the garment of acceptance before Saul and the people of Israel) – verse 2.",
            "Jonathan and David made a covenant because he loved him as his own soul – verse 3 (God never intended that relationship to be short-term, but long-lived).",
            "Jonathan stripped himself of the robe that was upon him, and gave it to David – verse 4 (This was an impartation, giving his privilege and particulars to David).",
            "David did not take all these for granted; he behaved himself wisely – verse 5."
        ],
        discussion_question: [
            {
                question: "What are friends for?",
                answer: [
                    "Mutual help.",
                    "Upgrading each other’s potential.",
                    "Defending or giving safety hints during hostile times.",
                    "Inspiring each other to higher heights.",
                    "Elevating a fellow person."
                ]
            },
            {
                question: "How can friendship be played out?",
                answer: [
                    "Relationship – Prov. 13:20.",
                    "Mentoring – Heb. 7:7.",
                    "Connection – Eccl. 4:9.",
                    "Association – Prov. 27:17.",
                    "Solidarity – Eccl. 4:11.",
                    "Synergy – Eccl. 4:12.",
                    "Affiliation – Eccl. 4:10."
                ]
            },
            {
                question: "How can one identify a friend?",
                answer: [
                    "When you have a divine stirring within you as you meet the person – I Sam. 18:1.",
                    "When his idea or reasoning tickles your fancy.",
                    "Each time you meet with him/her, something is supernaturally added to you.",
                    "When you see he/she is all out for your good.",
                    "He/she is a secret informant to you."
                ]
            },
            {
                question: "What lessons to learn from the friendship of Jonathan and David?",
                answer: [
                    "Jonathan was a mentor to David – He knew what David didn’t know.",
                    "Jonathan recognized his divine affiliation with David and held on to it by covenant – I Sam. 18:1,3.",
                    "God used Jonathan to pave the way for David to access the throne he was anointed for. In other words, a destiny helper to David – I Sam. 18:4, I Sam. 19:1-7.",
                    "David didn’t take things for granted; he was humble and behaved himself wisely before Saul. Saul assigned him higher duty – I Sam. 18:5."
                ]
            }
        ],
        conclusion: "Friendship is like a destiny ladder that can take you to your greatness, popularity, and prominence. (I Sam. 18:6-7; 19:4-8).",
    },
    {
        lesson: "Lesson 18",
        date: "SUNDAY 3RD November, 2024",
        topic: "THE MAN THAT FEARS GOD SHALL BE BLESSED",
        text: "Psalm 128:1-6",
        memory_verse: "GEN. 22:12 - “And he said, lay not thine hand upon the lad, neither do thou any thing unto him: for now I know that thou fearest God, seeing thou hast not withheld thy son, thine only son from me”",
        aim: "To encourage believers to showcase reverential fear to God, whether convenient or not.",
        introduction: "Read the week’s devotional. Abraham was the 1ST person in the Bible to show that he has fear for God. This kind of fear is called reverential fear; this is not fearing God because of punishment, it is fearing God as an act of obedience in worship and because of who He is: The Almighty God. Any man or woman that fears God shall be blessed for doing so. Today, we sing “Abraham’s blessings are mine, I am blessed in the morning, blessed in the evening, Abraham’s blessings are mine”. This was because he had reverential fear for God.",
        main_point: [
            "Blessing is for those who fear God and walk in His ways - Verse 1",
            "This blessing comprises: Profiting, Happiness and well-being. (Personal blessing) – Vs. 2",
            "Other blessings include: fruitful womb, flourishing home and thriving children. (family blessing) –Vs. 3",
            "Next is, blessing outside one’s house, enjoying goodness of the land all the days of one’s life (city or community blessing).",
            "Last is, seeing children’s children and living in peace (Generational blessing) – Vs.6"
        ],
        discussion_question: [
            {
                question: "How should we fear God?",
                answer: [
                    "Fearing God is akin to honouring Him.",
                    "By Honouring God.",
                    "By Reverencing God.",
                    "Act in line with the understanding that He has the whole Heaven and Earth.",
                    "Walk in line with His word",
                    "Submit to the leading of the Holy Spirit",
                    "Recognize and celebrate His glory and majesty",
                    "Go out and tell others about His goodness and mercy."
                ]
            },
            {
                question: "What is the content of the Blessing for fearing the Lord?",
                answer: [
                    "You shall not be denied or deprived of the reward of your labour - Ps. 128:2a.",
                    "You will not live a life of sorrow – Vs. 2b",
                    "You will have enhanced well-being Vs. 2c",
                    "Family blessing – children and resources shall increase and multiply – Vs. 3a",
                    "Your marriage shall be purposeful and your wife productive.",
                    "You’ll be blessed in your city and in the field.",
                    "You will enjoy generational blessing – of seeing your children’s children.",
                    "You’ll enjoy divine allocation irrespective of your location"
                ]
            },
            {
                question: "Who set the example of enjoying blessings from fearing the Lord?",
                answer: [
                    "Abraham – Gen. 22:12.",
                    "He was addicted to obeying God’s instruction whether convenient or not.",
                    "He had a strong reverential fear for God. For this he was made great by God.",
                    "He did not withhold his son, his only son from being used for sacrifice to God. However, it was God who stopped him.",
                    "He was completely committed to God and determined to serve God."
                ]
            }
        ],
        conclusion: "Fear of God fetches for someone God’s wisdom. It brings profiting in one’s endeavor, happiness, personal and business breakthroughs."
    },

    {
        date: "SUNDAY 10TH NOVEMBER, 2024",
        lesson: "Lesson 19",
        topic: "RAISE THE PRAISE: IT SHALL BE WELL!",
        text: "Acts 16:25-27",
        memory_verse: `Psalm 67:3 -  "Let the people praise thee, O God; let all the people praise thee."`,
        central_truth: "The praise is raised when all the people are in praise.",
        aim: "To encourage believers to be in continual praise no matter the adverse condition they may face.",
        introduction: "Read this week’s devotional. God is glad when we raise the praise. As a result, He continually opens His heart to us. He grants us our requests, opens the door for us and helps us to break barriers that fight our growth. When praise is low, morale is low. When we raise the praise, revival is enforced and well-being is enhanced. David and his people knew that the secret of freedom, increase and well-being is to raise the praise (Ps. 67:3, 5-7). Do you want all to be well with you? Then, raise the frequency of the praise to God.",
        main_point: [
            "Midnight determines what shape the day will take. If we raise the praise at midnight, then the daybreak will be a good day.",
            "Loud praise gives us dominion over the environment and our territories – Vs. 25",
            "Loud praise to God triggers the supernatural earthquake that opens all closed doors and lead people into freedom – Vs. 26",
            "When the praise is raised, any enemy who does not want things to be well with you will attempt suicide – Vs. 27"
        ],
        discussion_question: [
            {
                question: "What is Raise the Praise?",
                answer: [
                    "Shout loud and extol the name of the Lord.",
                    "Say sweet things to God with a sense of vehemence and vibrancy.",
                    "Give thanks to God with your voice raised and the atmosphere filled with your emotion towards God for His love and faithfulness.",
                    "Speak out very audibly about God’s mercy and compassion towards you and your family.",
                    "Lift up your voice in testimonies and spell out the possibilities He has brought forth in your life.",
                ]
            },
            {
                question: "What does 'It shall be well' specify?",
                answer: [
                    "Promise of well-being for the faithful and consistent believer.",
                    "Prophecy of a far better future.",
                    "A decree instructing your enemies to stop attacking you.",
                    "An encouragement that things will change for good.",
                    "A declaration that you are a light no darkness can quench.",
                ]
            },
            {
                question: "Raise the Praise: It shall be well - what does this mean?",
                answer: [
                    "Our well-being is tied to our praise – filled life.",
                    "When we increase our praise to God, we attract good things to happen to us.",
                    "As we raise the praise to God it becomes easy for us to experience freedom and obtain breakthroughs.",
                ]
            },
            {
                question: "What are the conditions to fulfill 'It shall be well'?",
                answer: [
                    "Take it as a faith confession. So keep confessing it to yourself and your family.",
                    "Raise the praise and you experience open doors.",
                    "Take it as a prayer declaration. Keep at it.",
                    "If fasting is added – It shall be well.",
                    "It shall be well when supply is available.",
                    "If sin is shunned, it shall be well with you.",
                    "It shall be well; By Grace of Recovery."
                ]
            },
        ],
        conclusion: "By now, your eyes must have been opened. May you now know how to attract increase, freedom and open doors to yourself."
    },
    {
        lesson: "Lesson 20",
        date: "SUNDAY 17TH NOVEMBER, 2024",
        topic: "STEPS OF FAVOUR",
        text: "2 Corinthians 9:6-7",
        memory_verse: "James 4:10",
        memory_text: "Humble yourselves in the sight of the lord, and he shall lift you up.",
        central_truth: "Arrogance robs us of favour but humility brings it in abundance.",
        aim: "To help believers know how to step into favour day by day.",
        introduction: "Go through the week’s devotional for more insight. We serve a God who loves to favour His children. One act of favour can address several year of need and labour. For this reason, it is necessary to know what steps to take in order to attract favour from God. This day’s SUNDAY school lesson has laid out those steps and our ability to apply each of them will bring favour to us day by day.",
        main_point: [
            "Sow (or give) less, get less. Sow in abundance, get back in abundance.",
            "Listen to your heart before you sow (or give), it will instruct you on how to do it to attract favour.",
            "Giving grudgingly leads to gloomy life.",
            "Key into cheerful giving, God loves it and uses it to favour us abundantly."
        ],
        discussion_question: [
            {
                question: "What is favour?",
                answer: [
                    "An act of kindness and assistance",
                    "It is God fending or fighting for us.",
                    "Having victory where we were supposed to fall victim",
                    "Outstanding success from minimal effort.",
                    "Unction to function effectively in our endeavors.",
                    "The result that replaces insult.",
                    "An alleviation of labour and toils"
                ]
            },
            {
                question: "What do we mean by “steps of favour”?",
                answer: [
                    "Spiritual strategies that triggers favour",
                    "Actions taken at convenient or non-convenient times that fetch us God’s help.",
                    "Ventures that God opens our eyes to embark upon that yields for us exceptional results.",
                    "Opportunities we don’t allow pass us by."
                ]
            },
            {
                question: "How to carry the consciousness of favour:",
                answer: [
                    "Understanding that favour is of the Lord not by man’s labour – Psalm 44:3.",
                    "Being conscious that God will always fight our battles – 2 Chron. 20:17.",
                    "God is faithful to grant us a way to escape from vicissitudes of life – I Cor. 10:13.",
                    "God will supply our needs – Phil. 4:13.",
                    "God is for us – Rom. 8:31",
                    "God’s mercy is available for us - Rom. 9:16",
                    "When we give, God will give us back - Luke 6:38"
                ]
            },
            {
                question: "ACTION THAT TRIGGERS FAVOUR:",
                answer: [
                    "Praise God – Psalm 146:2",
                    "Tell God what you want – Matt. 7:7",
                    "Humble yourself – James 4:10",
                    "Give cheerfully – 2 Cor. 9:6,7",
                    "Put all your trust in God – Psalm 118:8",
                    "Walk closely with God – James 4:8",
                    "Live holy – I Pet. 1:16"
                ]
            },
            {
                question: "Habits that fetches favour:",
                answer: [
                    "Being humble in the sight of God.",
                    "Refusing to manipulate others to get to the top",
                    "Minimizing self-ego and self-interest.",
                    "Working and wanting for God’s appointed time to lift us up.",
                    "Patiently waiting for God to strengthen us for favour."
                ],
            }
        ],
        conclusion: "Favour is one commodity that is always in demand. When you yield yourself to God, you will have abundance of it. As you humble yourself before God and man, you’ll never be in short supply of favour. Just hold unto the steps of favour."
    }
    ,
    {
        lesson: "Lesson 21",
        date: "SUNDAY 24TH November, 2024",
        topic: "LIVING ACCORDING TO GOD’S PATTERN",
        text: "Deut. 10:12-13, Heb. 8:5",
        memory_verse: "John 15:12 - “This is my commandment, that ye love one another, as I have loved you.”",
        central_truth: "Try to love one another as God loves us.",
        aim: "To let every believer know that God wants us to relate with one another in love as His pattern is.",
        introduction: "Go through the week’s devotional for details. God’s commandment is God’s pattern. The pattern He showed and still shows us is to love one another as He Himself loves us. Living according to God’s pattern is simply to showcase unconditional love to one another. Without this pattern, Moses wouldn’t have been able to build the Tabernacle according to the pattern shown to him in the mount, through the offerings brought to him with a heart of one love.",
        main_point: [
            "God’s pattern requires that we: fear Him and love Him.",
            "Walk in all His ways.",
            "Serve Him with all our hearts and soul.",
            "Keep the commandments and His statutes.",
            "Doing all the above is for our personal good and collective bliss."
        ],
        discussion_question: [
            {
                question: "What’s God’s pattern for us?",
                answer: [
                    "Micah 6:8 gives three things of what God’s standard of goodness and commitments to Him are:",
                    "We must act justly – being fair and honest in our dealings with one another (Matt. 7:17).",
                    "We must love mercy – show genuine compassion to individuals in need.",
                    "We must work humbly with our God – Humble ourselves daily in godly fear and reverence for His will (James 4:6-10; I Peter 5:5-6)."
                ]
            },
            {
                question: "How can we love according to God’s pattern?",
                answer: [
                    "Emulate and show greater love towards our friends – John 15:13.",
                    "Take actions to create an atmosphere of great peace amongst us – Psalm 119:165.",
                    "Stay joyous as we serve a joyous God – 3 John 4.",
                    "Let someone connect with us in an atmosphere of a friend’s love – Prov. 17:17.",
                    "Always glory in His name – I Chron. 16:10.",
                    "Live to allow God’s love to defend us – Psalm 118:6.",
                    "Our lives should exemplify humility because God loves humility – 2 Sam. 22:28."
                ]
            },
            {
                question: "Who are the Moses of today according to Heb. 8:5?",
                answer: [
                    "The Ministers of God and SUNDAY School Teachers.",
                    "Our messages and teachings should be geared towards building good and godly character in our members and students.",
                    "Our prayer is to shape them into becoming vessels of honour and integrity for God’s use.",
                    "Our lessons should uplift them spiritually, scripturally, morally, intellectually, and dutifully."
                ]
            }
        ],
        conclusion: "We can rightly say that it takes the fear of God and walking according to the pattern of His word to lead to an acceptable standard of worship."
    },
    {
        lesson: "Lesson 22",
        date: "SUNDAY 1ST December, 2024",
        topic: "LIVING TO PLEASE GOD",
        text: "Hebrews 11:1, 5-6",
        memory_verse: `Prov. 16:7 - “When a man’s ways please the Lord, he maketh even his enemies to be at peace with him”`,
        aim: "To let believers know that when we live to please God, God will stay to bless us.",
        central_truth: "When we live to please God, God will not leave any stone unturned to satisfy us.",
        introduction: `Read the week’s devotional. No man can virtually obtain favour from someone he does not please. Likewise God, He will allow us to have a delightful life when we live a life pleasing to Him, like Enoch did. Meaning, numerous blessings can be derived by aligning our lives to please God. One can only live to please God by faith.`,
        main_point: [
            "Faith is what is hoped for - Vs. 1",
            "By faith Enoch had this testimony that he pleased God – Vs. 5",
            "But without faith it is impossible to please God – Vs. 6a",
            "As you come to God, believe He will reward you if you diligently seek Him – Vs. 6b"
        ],
        discussion_question: [
            {
                question: "What does “Living to please God” mean?",
                answer: [
                    "Walk worthy of the Lord (be agreeable with God).",
                    "Bearing fruits of good works (shun sin, do good).",
                    "Growing in knowledge of God (Study His word).",
                    "Being strengthened in His glorious power (through fasting and prayer).",
                    "Being strengthened unto all patience and longsuffering yet being joyful.",
                    "Giving thanks unto God the Father continually."
                ],
            },
            {
                question: "How can you be living to please God?",
                answer: [
                    "Have faith in God – for without faith no one can please God - Heb. 11:6.",
                    "Be spiritually minded – Rom. 8:6-8.",
                    "Fear God – Psalm 147:11",
                    "Study and follow the example of Jesus Christ – Matt. 17:5.",
                    "Obey God – I Sam. 15:22.",
                    "Give the sacrifice God wants – Heb. 13:15-16."
                ],
            },
            {
                question: "Who are the two people in the Old Testament and New Testament who lived to please God?",
                answer: [
                    "O.T. – Enoch - Heb. 11:5",
                    "N.T. – Jesus - Matt. 3:17"
                ],
            },
            {
                question: "How can you do a self-check about living to please God?",
                answer: [
                    "Read I Corinthians 11:31-32.",
                    "Examine yourself: Am I living to please God?",
                    "Is my daily lifestyle in line with God?",
                    "God wants us to examine and judge ourselves."
                ],
            },
        ],
        conclusion: "From the text of this lesson, Heb. 11:5-6 and the memory verse Prov. 16:7, we can deduce the benefits of living a life pleasing to God as follows: enjoying divine presence, fruitfulness, victory over our enemies, spiritual growth, being announced by God, and being free from sin.",
    },
    {
        lesson: "Lesson 23",
        date: "SUNDAY 8TH December, 2024",
        topic: "WALKING IN THE TRUTH",
        text: "2 Cor. 4:2; 2 John 1:4",
        memory_verse: `John 8:32 - “And ye shall know the truth, and the truth shall make you free”`,
        central_truth: "Conscience is an open wound only the truth can heal it.",
        aim: "To encourage believers to walk in truth, not in craftiness nor handle the work or word of God deceitfully.",
        introduction: `Endeavour to go through the week’s devotional. Life is a journey in which you know when you had started but don’t know when you are ending. Walking in the truth also has a bearing on and an impression of a journey. This journey is one done in truth (the Christ) John 14:6. When you walk in Christ, you have to walk in the knowledge of spiritual principles and the truth in God’s word.`,
        main_point: [
            "You have to renounce hidden things of dishonesty – Vs. 2",
            "Walk in manifestation of the truth",
            "Commend ourselves to good conscience in the sight of God – Vs. 2",
            "Walk in truth as we have received a commandment from the Father to do."
        ],
        discussion_question: [
            {
                question: "What does it mean: ‘Walking in the Truth’?",
                answer: [
                    "Living a word-based lifestyle.",
                    "Aligning your thoughts and actions with scriptural guidelines.",
                    "Walking and working to please God.",
                    "Following inspired instructions to stay on course with God.",
                    "Not compromising with deceit and falsehood in the world.",
                    "Watching over the grace upon your life and not allowing it to get into abuse."
                ],
            },
            {
                question: "How do we walk in the Truth?",
                answer: [
                    "Let justice roll on in our relationships.",
                    "In Him (Jesus) and through faith in Him we approach God.",
                    "Keep to the good taste and see the goodness in serving God.",
                    "Call and run into the name of the Lord daily (This speaks of following a daily prayer routine).",
                    "Walking in the consciousness that grace is already available for our exploits.",
                    "Relate well with God so that He may be pleased to announce and endorse us for His glory.",
                    "Keep to wisdom that yields patience and shun offence."
                ],
            },
            {
                question: "Why do we need to walk in Truth?",
                answer: [
                    "In order to stay clear of the hidden things of dishonesty.",
                    "So that we take heed to manifest the truth in our lives.",
                    "To keep to good conscience.",
                    "To obey the commandment to walk in Truth."
                ],
            },
            {
                question: "What are the benefits of walking in the truth?",
                answer: [
                    "Freedom from satanic oppression.",
                    "Live in truth and model truth.",
                    "Increase in knowledge of God.",
                    "Grow in grace.",
                    "Live a triumphant life.",
                    "Increase in unction.",
                    "Restoration from falsehood.",
                    "Grow in spiritual health.",
                    "Live a transparent life.",
                    "Bear good testimony towards God."
                ],
            },
        ],
        conclusion: "When we walk in truth, we increase in wisdom, inspiration, and become agents of transformation.",
    },
    {
        lesson: "Lesson 24",
        date: "SUNDAY 15TH December, 2024",
        topic: "NEVER WAIVER IN YOUR TRUST IN GOD",
        text: "Job 13:13-16",
        memory_verse: `Job 13:15 - “Though he slay me, yet will I trust in him: but I will maintain mine own ways before him.”`,
        central_truth: "It is your steadfastness that strengthens God’s faithfulness towards your life and ministry.",
        aim: "To let believers know how to turn difficulty to possibility.",
        introduction: `Read the week’s devotional for some level of guidance. We are told never to waiver in our trust in God. Though the experience may be extremely difficult, just persevere and know that God will not fail. He will ultimately come to our rescue and turn every difficulty to possibility. The story of Job suffices, where he passed through moments of great sorrow, trials, and tribulation but at the end enjoyed recuperation and restoration.`,
        main_point: [
            "A determination to hold on to the end – Vs. 13",
            "Sometimes you need to risk life in order to reach God’s provision for your life – Vs. 14",
            "A decision not to shift, trusting God – Vs. 15",
            "Salvation, victory, and deliverance will come at last; no hypocrisy survives around God – Vs. 16"
        ],
        discussion_question: [
            {
                question: "What is that one word that stands for ‘Never waiver in your trust in God’?",
                answer: [
                    "The word is: Steadfastness."
                ],
            },
            {
                question: "What is the aim of steadfastness here?",
                answer: [
                    "Aims at multiplying your joy and eroding your grief.",
                    "It is what makes you stand out among colleagues or peer group.",
                    "It witnesses for you when wicked ones or the devil attempt to attack you (Job 1:8).",
                    "It renews God’s love towards you every morning.",
                    "Like a good friend of a true believer, steadfastness is a lift when you are down, a smile when you are sad, and a good song when you are depressed.",
                    "Steadfastness is a status of loyalty where a believer will never waiver in his/her trust in God."
                ],
            },
            {
                question: "What to do during moments of tribulation?",
                answer: [
                    "Spend time singing and praising God.",
                    "Ask strength from God to withstand and conquer.",
                    "Maintain strong faith and trust in God.",
                    "Avoid doubting God.",
                    "Trust God’s ability to meet you at your point of need."
                ],
            },
            {
                question: "How do we show trust in God?",
                answer: [
                    "Always reflect on God’s past faithfulness.",
                    "Meditate on the word of God.",
                    "Live a life of unwavering faith.",
                    "Obey God’s commands.",
                    "Pray continually for God’s help."
                ],
            },
        ],
        conclusion: "God’s faithfulness is as strong as we stay with Him, no matter the tribulations. No matter how rough it is, the God of Job will definitely come to your aid. Therefore, don’t waiver, stay put, trust Him and watch Him transform your situation.",
    },
    {
        lesson: "Lesson 25",
        date: "SUNDAY 22ND December, 2024",
        topic: "BUILDING UP OTHERS IN THE LORD",
        text: "Romans 15:1-7",
        memory_verse: `Rom. 14:19 - “Let us therefore follow after the things which make for peace and things wherewith one may edify another.”`,
        aim: "To show believers how to build up one another in the Lord.",
        central_truth: "As you build up others in the Lord, God by His love will build you up for greater exploits.",
        introduction: `Read the week’s devotional for deeper insight. It is often said: “As the hand scratches the back, so the back scratches (or nabs) the hand.” That means the process of building each other is mutual and reciprocal. No one can grow alone in the house of God. One person needs to edify another and vice-versa. Besides, upgrading one another, the building process sponsors peace, harmony, and mutual co-existence in the body of Christ.`,
        main_point: [
            "The strong should help the weak – Vs. 1",
            "Everyone should endeavor to edify one another – Vs. 2",
            "The reproach upon us fell upon Jesus – Vs. 3",
            "Every written word is for our learning – Vs. 4",
            "We should be likeminded – Vs. 5",
            "We should glorify God with one mind and one mouth – Vs. 6",
            "We should gladly receive one another as Christ received us – Vs. 7"
        ],
        discussion_question: [
            {
                question: "What are the requirements for building up others in the Lord?",
                answer: [
                    "Help of the Holy Spirit",
                    "Yielding to divine instructions",
                    "An atmosphere of peace",
                    "Release of impartation on others",
                    "Willingness to be our brother’s keeper",
                    "Practice of self-denial",
                    "Following the example of Jesus"
                ],
            },
            {
                question: "How to build up others in the Lord?",
                answer: [
                    "Bear the infirmities of the weak – Rom. 15:1",
                    "Please your neighbor – Rom. 15:2",
                    "Follow the pace set by Christ – Rom. 15:3",
                    "Have hope of being rewarded – Rom. 15:4",
                    "Be likeminded – Rom. 15:5",
                    "Do it to Glorify God – Rom. 15:6",
                    "Always be willing to receive one another – Rom. 15:7"
                ],
            },
            {
                question: "Why build up others in the Lord?",
                answer: [
                    "To show that we don’t please ourselves only.",
                    "To fulfill a desire to edify others",
                    "To relieve people of reproaches",
                    "To apply patience and comfort others",
                    "To be likeminded to glorify God",
                    "Receive one another as Christ also received us"
                ],
            },
            {
                question: "What benefits to build others in the Lord?",
                answer: [
                    "To open the door for help coming to us – Prov. 11:25",
                    "To qualify for God’s mercy – Matt. 5:7",
                    "To attract help of the Holy Spirit as we pray – Rom. 8:26",
                    "Strengthens our hope in God for a change of story and a better tomorrow – 1 Kings 17:9, 14-16",
                    "Imputed to us for righteousness – Rom. 4:23-24",
                    "To avoid rejection in our lives and in our endeavors – Rom. 15:7"
                ],
            },
        ],
        conclusion: "Just as respect is reciprocal, so is building up others in the Lord, returning favor, provisions, and privileges to us. By doing this, the God of comfort and consolation will always be there for us at the point of our needs.",
    },
];
